import { css } from 'linaria';

export const headerBackBtn = css`
  @media (--only-mobile) {
    grid-template-columns: var(--space-200) auto var(--space-200) 1fr var(--space-200) !important;
  }
`;
